import * as actionTypes from './actionTypes';
import { validateAccessService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import { fetchAccess } from '@app/src/common/session';
import validExistsToken from '@app/src/utils/access';

const isClient = isClientEnv();

const fetchValidateRequest = () => ({
  type: actionTypes.FETCH_VALIDATE_ACCESS_REQUEST
});

const fetchValidateFailure = () => ({
  type: actionTypes.FETCH_VALIDATE_ACCESS_FAILURE
});

const fetchValidateSuccess = (data) => ({
  type: actionTypes.FETCH_VALIDATE_ACCESS_SUCCESS,
  data
});

export const clearValidateAccessData = () => ({
  type: actionTypes.CLEAR_VALIDATE_ACCESS_DATA
});

export const fetchValidateAccess = () => {
  return async dispatch => {
    dispatch(fetchValidateRequest());
    try {
      await validExistsToken(8);
      const data = await validateAccessService.post();
      if (data.error) {
        if (data.code === 400) {
          dispatch(actionsModalError.openModalError(data.message));
          /*setTimeout(() => {
            isClient && window.location.reload();
          }, 500);*/
        } else if (data.code === 401) {
          isClient && localStorage.removeItem('app');
          await dispatch(fetchAccess());
        } else {
          dispatch(fetchValidateFailure());
        }
      } else {
        dispatch(fetchValidateSuccess(data.data[0]));
        const app = JSON.parse(localStorage.getItem('app'));
        app['data'] = data.data[0];
        isClient && localStorage.setItem('app', JSON.stringify(app));
      }
    } catch(error) {
      console.log(`Error fetch validate action ${error}`);
      dispatch(actionsModalError.openModalError('Ocurrió un error'));
      dispatch(fetchValidateFailure());
    }
  }
}
